import React from 'react'
import Box from '@mui/material/Box'
import Stack from '@mui/material/Stack'
import { CategoryIcon, Text } from '@mxenabled/mxui'

import { useCategoryStore, useGlobalCopyStore } from '../../../context'
import { buildDynamicCopy } from '../../../../core/utils/Localization'

export const CategoryIconLabel: React.FC<{
  categoryGuid: string
  topLevelCategoryGuid: string
}> = ({ categoryGuid, topLevelCategoryGuid }) => {
  const { categories: copy } = useGlobalCopyStore()
  const { getCategoryName } = useCategoryStore()
  const categoryName = getCategoryName(categoryGuid)

  return (
    <Stack alignItems="center" direction="column" gap="8" justifyContent="center" mb={4}>
      <Box
        aria-label={buildDynamicCopy(copy.category_icon_label_aria, categoryName) as string}
        mb={4}
        role="img"
      >
        <CategoryIcon categoryGuid={topLevelCategoryGuid} />
      </Box>
      <Text variant="body1">{categoryName}</Text>
    </Stack>
  )
}
